export default __webpack_public_path__ + "static/media/bundle.a5e495bb.less";